import { parse } from 'querystring';

interface ActionsParams {
    scrollTo?: string;
}

export const getActionsParams = (url: string) => {
    const actions = url
        .split('#')
        .find((i) => i.startsWith('actions'))
        ?.replace('actions?', '');

    const obj = parse(actions ?? '');
    return (obj ? obj : {}) as ActionsParams;
};
